import React, { useState, useCallback, useMemo } from "react";

import { Link } from "gatsby";

import { Menu, MenuItem, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import { getEntityUrl, getTranslatedTopbarEntities } from "../../util";

import LanguageMenu from "../LanguageMenu";

import LanguageSelectionLink from "./languageSelectionLink";

const MainMenu = (props) => {
    const { locales, entity, pageContext, settings, entities } = props || {};
    const curLocale = pageContext?.locale;
    const defaultLocale = pageContext?.defaultLocale;

    const translatedTopbarEntites = getTranslatedTopbarEntities(settings, entities, curLocale);

    const linkToStartpage = useMemo(() => {
        if (typeof window !== 'undefined' && window.location.pathname === '/languages') return 'none'
        return settings?.nodes[0]?.Topbar?.linkToStartpage || 'none';
    });

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = useCallback((e) => {
        e.stopPropagation();
        setAnchorEl(null);
    }, [setAnchorEl]);

    return <>
        {(translatedTopbarEntites.length > 0 || linkToStartpage !== 'none') && <>
            <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={handleMenu}
                size="large">
                <MenuIcon />
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} getContentAnchorEl={null} keepMounted style={{ zIndex: 65535 }}
                anchorOrigin={{ vertical: "bottom", horizontal: "right", }} >

                {linkToStartpage === 'menuTop' && <LanguageSelectionLink onClick={handleClose} locale={entity?.locale || defaultLocale} />}

                {translatedTopbarEntites?.map(e =>
                    <MenuItem key={e.identifier} onClick={handleClose} component={Link} to={getEntityUrl({ entity: e, defaultLocale })}>
                        {e.title}
                    </MenuItem>
                )}

                <LanguageMenu {...{ locales, curLocale, defaultLocale, handleClose, entity, classes: {}, }} LinkComponent={MenuItem} />

                {linkToStartpage === 'menuBottom' && <LanguageSelectionLink onClick={handleClose} locale={entity?.locale || defaultLocale} />}
            </Menu>
        </>}
    </>;
}

export default MainMenu;
